import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

/**
 * @important The values in the select have to be added in the campaign service also, otherwise the backend validation will fail.
 */
export default function CampaignLabelSelect({ showDisabledOptions = false, ...props }) {
  return (
    <Select {...props}>
      <Option key="Customer service" value="Customer service">
        Customer service
      </Option>
      <Option key="Driver referral" value="Driver referral">
        Driver referral
      </Option>
      <Option key="Service Advisors" value="Service Advisors">
        Service Advisors
      </Option>
      <Option key="Supply - Partnership" value="Supply - Partnership">
        Supply - Partnership
      </Option>
      <Option key="Partner" value="Partner">
        Partner
      </Option>
      <Option key="Email campaign (repeat)" value="Email campaign (repeat)">
        Email campaign (repeat)
      </Option>
      <Option key="Email campaign (lead)" value="Email campaign (lead)">
        Email campaign (lead)
      </Option>
      <Option key="Seasonal Marketing" value="Seasonal Marketing">
        Seasonal Marketing
      </Option>
      <Option key="Affiliate" value="Affiliate">
        Affiliate
      </Option>
      <Option key="Awin" value="Awin">
        Awin
      </Option>
      <Option key="Other - Evergreen" value="Other - Evergreen">
        Other - Evergreen
      </Option>
      <Option key="Out of Home" value="Out of Home">
        Out of Home
      </Option>
      <Option key="Employee Discount" value="Employee Discount">
        Employee Discount
      </Option>
      <Option key="ECC" value="ECC">
        ECC
      </Option>
      <Option key="Credit Replacement" value="Credit Replacement">
        Credit Replacement
      </Option>
      {/**
       * @note There are old records in DB using these values, so we need to disable them instead of deleting.
       */}
      {showDisabledOptions && (
        <Option
          key="__divider__"
          disabled
          value="__divider__"
          className="ant-select-dropdown-menu-item-divider"
        >
          {' '}
        </Option>
      )}
      {showDisabledOptions && (
        <Option key="Sales leads" disabled value="Sales leads">
          Sales leads
        </Option>
      )}
      {showDisabledOptions && (
        <Option key="Online promotion" disabled value="Online promotion">
          Online promotion
        </Option>
      )}
      {showDisabledOptions && (
        <Option key="Customer referral" disabled value="Customer referral">
          Customer referral
        </Option>
      )}
      {showDisabledOptions && (
        <Option key="(none)" disabled value="">
          (none)
        </Option>
      )}
    </Select>
  );
}
